export const RulePresetNoPresence = {
  initial_presence_time_epochs_gte: {
    default: 10,
    exclusiveMinimum: 0,
    exclusiveMaximum: 1440,
  },
  no_presence_time_epochs_gte: {
    default: 5,
    exclusiveMinimum: 0,
    exclusiveMaximum: 10,
  },
  presence_time_epochs_gte: {
    default: 5,
    exclusiveMinimum: 0,
    exclusiveMaximum: 10,
  },
};

// awake
export const RulePresetAwake = {
  initial_presence_time_epochs_gte: {
    default: 20,
    exclusiveMinimum: 0,
    exclusiveMaximum: 1440,
  },
  awake_time_epochs_gte: {
    default: 15,
    exclusiveMinimum: 4,
    exclusiveMaximum: 120,
  },
  asleep_time_epochs_gte: {
    default: 10,
    exclusiveMinimum: 3,
    exclusiveMaximum: 120,
  },
};

export const RulePresetSoundLevel = {
  initial_presence_time_epochs_gte: {
    default: 10,
    exclusiveMinimum: 0,
    exclusiveMaximum: 1440,
  },
  sound_level_gte: {
    default: 70,
    exclusiveMinimum: 40,
    exclusiveMaximum: 140,
  },
};

export const RuleMovement = {
  initial_presence_time_epochs_gte: {
    default: 10,
    exclusiveMinimum: 0,
    exclusiveMaximum: 1440,
  },
  movement_mean_time_epochs_gte: {
    default: 5,
    exclusiveMinimum: 0,
    exclusiveMaximum: 1440,
  },
  movement_mean_gte: {
    default: 50,
    exclusiveMinimum: 1,
    exclusiveMaximum: 100,
  },
};

export const RuleDeviceOffline = {
  time_since_last_seen_gte: {
    default: 10,
    exclusiveMinimum: 5,
    exclusiveMaximum: 1440,
  },
};
